import styled from 'styled-components';
import AppButton from '../../../styles/common/AppButton';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const TabsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;
export const TabButton = styled(AppButton)`
  margin-left: 10px;
  border-radius: 0px;
  font-weight: bold;
  font-size: 0.9rem;
  :first-child {
    margin-left: 0px;
  }
  background-color: ${props =>
    (props.active && ColorSF2.skyBlue) || ColorSF2.paleBlue};
  color: ${ColorSF2.black};
  width: 100%;
  cursor: ${props => (props.active && 'default') || 'pointer'};
`;
